// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"Menu-StatelessMenu-module__buttonWrapper--wLHS1"};